<template>
  <div>
    <!-- Stays behind the page because the router-view wrapper below is position-relative and comes later in the DOM -->
    <FallingLeaves v-if="showLeaves" />
    <h1 v-if="isLoading" class="d-sr-only">{{ t(l.label_loading) }}</h1>
    <v-overlay attach="main" v-if="isLoading" :model-value="isLoading" class="align-center justify-center">
      <v-progress-circular
        color="primary"
        size="64"
        indeterminate
        :aria-label="t(l.label_loading)"
      ></v-progress-circular>
    </v-overlay>

    <div style="min-height: 600px" :class="{ 'position-relative': showLeaves }">
      <router-view v-slot="{ Component }">
        <transition v-if="!isLoading" name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useAreas, useCategories } from '@ilteducation/content-ref-data';
import useKeywordsStore from '@/store/keywords';
import useSubscriptions from '@/foundations/helpers/use-subscriptions';
import { useRoute } from 'vue-router';
import { computed, onMounted, ref } from 'vue';
import useSubjectsWithVideos from '@/composables/use-subjects-with-videos';
import { useLocale } from '@/plugins/translation';
import FallingLeaves from '@/components/FallingLeaves.vue';

const { t, l } = useLocale();
const isLoading = ref(true);
useKeywordsStore();
const { load: loadCategories } = useCategories();
const { load: loadAreas } = useAreas();
const route = useRoute();
const showLeaves = computed(() =>
  ['Videos', 'Guides', 'Materials', 'materialsSearch', 'Games'].includes(route.name as string),
);

onMounted(async () => {
  const subscriptions = useSubscriptions();
  useSubjectsWithVideos();
  await Promise.all([loadCategories(subscriptions.value[0].type)]);
  isLoading.value = false;
  loadAreas();
});
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease-in;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
